module.exports = __webpack_public_path__ + "img/u1218.89f93235.png";